var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modify-supplement-list" },
    [
      _c("el-card", [
        _vm.auditIds
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "space-between",
                  background: "#fdf6ec",
                  border: "1px solid #faecd8",
                  "border-radius": "4px",
                  padding: "8px 14px",
                  "margin-bottom": "12px",
                  "font-size": "13px",
                  color: "#e6a23c",
                },
              },
              [
                _c("span", [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(" 当前展示：待处理改补订单"),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text", size: "small" },
                    on: { click: _vm.clearAuditIds },
                  },
                  [_vm._v("查看全部")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "status-tabs" }, [
          _c(
            "div",
            {
              staticStyle: { display: "flex", "flex-wrap": "wrap", flex: "1" },
            },
            [
              _c(
                "el-button",
                {
                  class: [
                    "status-button",
                    { selected: _vm.selectedStatus === "全部" },
                  ],
                  staticStyle: { position: "relative" },
                  attrs: {
                    type: _vm.selectedStatus === "全部" ? "primary" : "default",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleStatusClick("全部")
                    },
                  },
                },
                [
                  _vm._v("\n          全部"),
                  _c("span", { staticClass: "status-badge" }, [
                    _vm._v(
                      _vm._s((_vm.statusCounts && _vm.statusCounts.total) || 0)
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.dict.after_productionstatus_total, function (item) {
                return _c(
                  "el-button",
                  {
                    key: item.value,
                    class: [
                      "status-button",
                      { selected: _vm.selectedStatus === item.value },
                    ],
                    staticStyle: { position: "relative" },
                    attrs: {
                      type:
                        _vm.selectedStatus === item.value
                          ? _vm.getTagType(item.value)
                          : "default",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleStatusClick(item.value)
                      },
                    },
                  },
                  [
                    _vm._v("\n          " + _vm._s(item.label)),
                    _vm.getStatusCount(item.value) > 0
                      ? _c("span", { staticClass: "status-badge" }, [
                          _vm._v(_vm._s(_vm.getStatusCount(item.value))),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "合同号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入合同号", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.contractNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "contractNo", $$v)
                        },
                        expression: "searchForm.contractNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "原合同号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入原合同号", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.originalContractNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "originalContractNo", $$v)
                        },
                        expression: "searchForm.originalContractNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单号" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入订单号", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.productionOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "productionOrder", $$v)
                        },
                        expression: "searchForm.productionOrder",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户名称" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户名称", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户电话" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "请输入客户电话", clearable: "" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearchClick($event)
                        },
                      },
                      model: {
                        value: _vm.searchForm.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "mobile", $$v)
                        },
                        expression: "searchForm.mobile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showMoreSearch,
                          expression: "showMoreSearch",
                        },
                      ],
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        width: "100%",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户地址" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入客户地址",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "address", $$v)
                              },
                              expression: "searchForm.address",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入门店名称",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.storeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "storeName", $$v)
                              },
                              expression: "searchForm.storeName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "240px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd",
                              clearable: "",
                            },
                            on: { change: _vm.handleSearch },
                            model: {
                              value: _vm.createDateRange,
                              callback: function ($$v) {
                                _vm.createDateRange = $$v
                              },
                              expression: "createDateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处理人" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入处理人",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.assignNickName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "assignNickName", $$v)
                              },
                              expression: "searchForm.assignNickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "接单人" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入接单人",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.orderNickName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "orderNickName", $$v)
                              },
                              expression: "searchForm.orderNickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "设计师" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入设计师",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.designerNickName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "designerNickName",
                                  $$v
                                )
                              },
                              expression: "searchForm.designerNickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发起改补人" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入发起改补人",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearchClick($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.afterCreateUserName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.searchForm,
                                  "afterCreateUserName",
                                  $$v
                                )
                              },
                              expression: "searchForm.afterCreateUserName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "处理时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "360px" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              clearable: "",
                            },
                            on: { change: _vm.handleSearch },
                            model: {
                              value: _vm.orderTimeRange,
                              callback: function ($$v) {
                                _vm.orderTimeRange = $$v
                              },
                              expression: "orderTimeRange",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "search-btn-item" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            _vm.showMoreSearch = !_vm.showMoreSearch
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.showMoreSearch ? "收起" : "展开") +
                            "\n            "
                        ),
                        _c("i", {
                          class: _vm.showMoreSearch
                            ? "el-icon-arrow-up"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.handleSearchClick },
                      },
                      [
                        _c("i", { staticClass: "el-icon-search" }),
                        _vm._v(" 搜索\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { plain: "" }, on: { click: _vm.resetSearch } },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider-line" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "12px",
              "text-align": "left",
              display: "flex",
              gap: "10px",
            },
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleCreateModifySupplement },
              },
              [_vm._v("发起改补")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-download" },
                on: { click: _vm.openExportDialog },
              },
              [_vm._v("导出")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { icon: "el-icon-setting" },
                on: { click: _vm.openConfigDialog },
              },
              [_vm._v("列配置")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              "element-loading-text": "正在加载数据...",
              "element-loading-spinner": "el-icon-loading",
              "element-loading-background": "rgba(255, 255, 255, 0.8)",
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "contractTable",
                staticStyle: {
                  width: "100%",
                  "margin-bottom": "20px",
                  "font-size": "14px",
                },
                attrs: {
                  data: _vm.contractList,
                  "header-cell-style": {
                    backgroundColor: "#e8eaed",
                    color: "#333",
                    fontWeight: "bold",
                  },
                  "cell-style": { paddingBottom: "6px", paddingTop: "6px" },
                  border: "",
                  "row-key": "rowId",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "45" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "270", fixed: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          ["未提交", "订单退回", "退回", "回退"].includes(
                            scope.row.productionStatus
                          )
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleOrderContract(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("下单")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkPer(["admin", "modifySupplement:edit"])
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleEditPage(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkPer(["admin", "modifySupplement:pay"]) &&
                          _vm.canPayRow(scope.row)
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#67C23A" },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handlePay(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row._contractAfter &&
                                        scope.row._contractAfter.payTime
                                        ? "查看付款"
                                        : "付款"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canCancelRow(scope.row)
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#F56C6C" },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleAuditBatchCancel(
                                        scope.row
                                      )
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkPer(["contract:syncContractStatus"])
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#606266" },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleSyncContract(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("同步")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm._l(_vm.visibleColumns, function (col) {
                  return _c("el-table-column", {
                    key: col.key,
                    attrs: {
                      label: col.label,
                      "min-width": col.minWidth || 120,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              col.key === "contractNo"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#409EFF",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleContractClick(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.contractNo || "-") +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : col.key === "productionOrder"
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#409EFF",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleViewMaterials(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.productionOrder || "-"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : col.key === "amount"
                                ? _c("span", [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          (scope.row.amount || 0).toFixed(2)
                                        )
                                    ),
                                  ])
                                : col.key === "afterChargedAmount"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.afterChargedAmount
                                          ? "¥" +
                                              Number(
                                                scope.row.afterChargedAmount
                                              ).toFixed(2)
                                          : "-"
                                      )
                                    ),
                                  ])
                                : col.key === "guideNickName" ||
                                  col.key === "designerNickName"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.parseNickName(scope.row[col.key]) ||
                                          "-"
                                      )
                                    ),
                                  ])
                                : col.key === "createTime"
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.createTime || "-")),
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row[col.key] || "-")),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "物料详情",
            visible: _vm.showMaterialDialog,
            width: "80%",
            top: "5vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showMaterialDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.materialLoading,
                  expression: "materialLoading",
                },
              ],
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.materialTab,
                    callback: function ($$v) {
                      _vm.materialTab = $$v
                    },
                    expression: "materialTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "酷家乐物料", name: "kujiale" } },
                    [
                      _vm.materialKujialeList.length > 0
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.groupByProductionOrder(
                                _vm.materialKujialeList
                              ),
                              function (group, gIdx) {
                                return _c(
                                  "div",
                                  {
                                    key: gIdx,
                                    staticStyle: { "margin-bottom": "16px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "6px 10px",
                                          background: "#f0f5ff",
                                          "border-left": "3px solid #409EFF",
                                          "margin-bottom": "8px",
                                          "font-size": "13px",
                                          "font-weight": "bold",
                                          color: "#303133",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                订单号：" +
                                            _vm._s(group.productionOrder) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: group.items,
                                          size: "mini",
                                          border: "",
                                          "max-height": "400",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            type: "index",
                                            label: "序号",
                                            width: "50",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "barCode",
                                            label: "板件编码",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "code",
                                            label: "编码",
                                            "min-width": "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "物料名称",
                                            "min-width": "130",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "typeName",
                                            label: "生产分类",
                                            "min-width": "70",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "length",
                                            label: "长",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "width",
                                            label: "宽",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "thk",
                                            label: "高",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "quantity",
                                            label: "数量",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "problemType",
                                            label: "问题类型",
                                            width: "110",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyPerson",
                                            label: "责任人",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyDept",
                                            label: "责任部门",
                                            width: "200",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "chargeType",
                                            label: "收费类型",
                                            width: "100",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "20px",
                                "text-align": "center",
                                color: "#909399",
                              },
                            },
                            [_vm._v("暂无酷家乐物料")]
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "原单物料", name: "original" } },
                    [
                      _vm.materialOriginalList.length > 0
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.groupByProductionOrder(
                                _vm.materialOriginalList
                              ),
                              function (group, gIdx) {
                                return _c(
                                  "div",
                                  {
                                    key: gIdx,
                                    staticStyle: { "margin-bottom": "16px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "6px 10px",
                                          background: "#f0f5ff",
                                          "border-left": "3px solid #409EFF",
                                          "margin-bottom": "8px",
                                          "font-size": "13px",
                                          "font-weight": "bold",
                                          color: "#303133",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                订单号：" +
                                            _vm._s(group.productionOrder) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: group.items,
                                          size: "mini",
                                          border: "",
                                          "max-height": "400",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            type: "index",
                                            label: "序号",
                                            width: "50",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "barCode",
                                            label: "部件编码",
                                            "min-width": "120",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "code",
                                            label: "编码",
                                            "min-width": "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "物料名称",
                                            "min-width": "130",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "typeName",
                                            label: "生产分类",
                                            "min-width": "70",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "length",
                                            label: "长",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "width",
                                            label: "宽",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "thk",
                                            label: "高",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "quantity",
                                            label: "数量",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "problemType",
                                            label: "问题类型",
                                            width: "110",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyPerson",
                                            label: "责任人",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyDept",
                                            label: "责任部门",
                                            width: "200",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "chargeType",
                                            label: "收费类型",
                                            width: "100",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "20px",
                                "text-align": "center",
                                color: "#909399",
                              },
                            },
                            [_vm._v("暂无原单物料")]
                          ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "其他物料", name: "other" } },
                    [
                      _vm.materialOtherList.length > 0
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.groupByProductionOrder(_vm.materialOtherList),
                              function (group, gIdx) {
                                return _c(
                                  "div",
                                  {
                                    key: gIdx,
                                    staticStyle: { "margin-bottom": "16px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "6px 10px",
                                          background: "#f0f5ff",
                                          "border-left": "3px solid #409EFF",
                                          "margin-bottom": "8px",
                                          "font-size": "13px",
                                          "font-weight": "bold",
                                          color: "#303133",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                订单号：" +
                                            _vm._s(group.productionOrder) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-table",
                                      {
                                        attrs: {
                                          data: group.items,
                                          size: "mini",
                                          border: "",
                                          "max-height": "400",
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            type: "index",
                                            label: "序号",
                                            width: "50",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "code",
                                            label: "编码",
                                            "min-width": "130",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "name",
                                            label: "物料名称",
                                            "min-width": "140",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "length",
                                            label: "长",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "width",
                                            label: "宽",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "thk",
                                            label: "高",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "quantity",
                                            label: "数量",
                                            width: "55",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "problemType",
                                            label: "问题类型",
                                            width: "110",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyPerson",
                                            label: "责任人",
                                            width: "100",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "dutyDept",
                                            label: "责任部门",
                                            width: "200",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "chargeType",
                                            label: "收费类型",
                                            width: "100",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "20px",
                                "text-align": "center",
                                color: "#909399",
                              },
                            },
                            [_vm._v("暂无其他物料")]
                          ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showExportDialog,
            title: "导出字段选择",
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "360px",
                overflow: "auto",
                padding: "10px",
              },
            },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.toggleExportSelectAll },
                  model: {
                    value: _vm.exportSelectAll,
                    callback: function ($$v) {
                      _vm.exportSelectAll = $$v
                    },
                    expression: "exportSelectAll",
                  },
                },
                [_vm._v("全选")]
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.exportSelectedFields,
                    callback: function ($$v) {
                      _vm.exportSelectedFields = $$v
                    },
                    expression: "exportSelectedFields",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
                    _vm._l(_vm.tableHeader, function (col) {
                      return _c(
                        "el-checkbox",
                        {
                          key: col.key,
                          staticStyle: { width: "50%", padding: "6px 0" },
                          attrs: { label: col.key },
                        },
                        [_vm._v(_vm._s(col.label))]
                      )
                    }),
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showExportDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.exportLoading },
                  on: { click: _vm.confirmExport },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.configDialogVisible,
            title: "列配置",
            width: "600px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.configDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                height: "300px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-right": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("可选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.tableHeader, function (col) {
                        return !col.visible
                          ? _c(
                              "div",
                              {
                                key: col.key,
                                staticStyle: {
                                  padding: "8px",
                                  "margin-bottom": "8px",
                                  "background-color": "#fff",
                                  border: "1px solid #ebeef5",
                                  "border-radius": "4px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumnVisible(col.key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(col.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      !_vm.tableHeader.some(function (col) {
                        return !col.visible
                      })
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无可选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-right",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return !col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToRight },
                    },
                    [_vm._v("全部显示")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-left",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToLeft },
                    },
                    [_vm._v("全部隐藏")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-left": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("已选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.visibleColumns, function (col) {
                        return _c(
                          "div",
                          {
                            key: col.key,
                            staticStyle: {
                              padding: "8px",
                              "margin-bottom": "8px",
                              "background-color": "#f5f7fa",
                              "border-radius": "4px",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleColumnVisible(col.key)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(col.label) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.visibleColumns.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无已选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.resetHeaderConfig } }, [
                _vm._v("重置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveHeaderConfig },
                },
                [_vm._v("保存配置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCancelDialog,
            title: "批量取消",
            width: "600px",
            top: "10vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCancelDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.cancelForm, "label-width": "130px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "销售单号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.cancelForm.orderNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderNo", $$v)
                      },
                      expression: "cancelForm.orderNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "合同号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.cancelForm.contractNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "contractNo", $$v)
                      },
                      expression: "cancelForm.contractNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户名称"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.cancelForm.custName,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "custName", $$v)
                      },
                      expression: "cancelForm.custName",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 客户地址"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.cancelForm.custAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "custAddress", $$v)
                      },
                      expression: "cancelForm.custAddress",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 下单日期"),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择下单日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.cancelForm.orderDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderDate", $$v)
                      },
                      expression: "cancelForm.orderDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "拆单日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择拆单日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.cancelForm.orderApprovalDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "orderApprovalDate", $$v)
                      },
                      expression: "cancelForm.orderApprovalDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "计划交货日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择计划交货日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.cancelForm.plannedDeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "plannedDeliveryDate", $$v)
                      },
                      expression: "cancelForm.plannedDeliveryDate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请日期"),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "请选择申请日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.cancelForm.applyDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "applyDate", $$v)
                      },
                      expression: "cancelForm.applyDate",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 申请原因"),
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入申请原因",
                      rows: "2",
                    },
                    model: {
                      value: _vm.cancelForm.applyReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "applyReason", $$v)
                      },
                      expression: "cancelForm.applyReason",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 取消后重新下单是否需要加急"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.cancelForm.urgentAfterReorder,
                        callback: function ($$v) {
                          _vm.$set(_vm.cancelForm, "urgentAfterReorder", $$v)
                        },
                        expression: "cancelForm.urgentAfterReorder",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "是", value: "是" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "否", value: "否" } }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入备注",
                      rows: "2",
                    },
                    model: {
                      value: _vm.cancelForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.cancelForm, "remark", $$v)
                      },
                      expression: "cancelForm.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附件" } },
                [
                  _c("CommonUpload", {
                    ref: "cancelFileUpload",
                    on: {
                      uploadSuccess: _vm.handleCancelFileUpload,
                      delSuccess: _vm.handleCancelFileDelete,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCancelDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.batchCancelLoading },
                  on: { click: _vm.confirmBatchCancel },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认付款",
            visible: _vm.showPayDialog,
            width: "560px",
            top: "8vh",
            "close-on-click-modal": true,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPayDialog = $event
            },
            open: _vm.loadPayData,
          },
        },
        [
          _c("div", [
            _vm.payLoading
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "center",
                      padding: "20px",
                      color: "#909399",
                    },
                  },
                  [
                    _c("i", { staticClass: "el-icon-loading" }),
                    _vm._v(" 加载中...\n      "),
                  ]
                )
              : _c(
                  "div",
                  [
                    _vm.payContractNo
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-bottom": "15px",
                              padding: "8px 12px",
                              background: "#f0f9eb",
                              border: "1px solid #e1f3d8",
                              "border-radius": "4px",
                              "font-size": "13px",
                              color: "#67C23A",
                            },
                          },
                          [
                            _vm._v(
                              "\n        合同号：" +
                                _vm._s(_vm.payContractNo) +
                                "\n      "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { size: "small", "label-width": "90px" } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款人" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.payInfo.payNickName || "-")
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款时间" } },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.payInfo.payTime || "-")
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款金额" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          gap: "8px",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            style: {
                                              flex: 1,
                                              color:
                                                _vm.payInfo.chargeAmount == null
                                                  ? "#C0C4CC"
                                                  : "#303133",
                                              fontWeight:
                                                _vm.payInfo.chargeAmount == null
                                                  ? "normal"
                                                  : "bold",
                                              fontSize: "14px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.payInfo.chargeAmount ==
                                                    null
                                                    ? "请确认报价"
                                                    : "¥" +
                                                        Number(
                                                          _vm.payInfo
                                                            .chargeAmount
                                                        ).toFixed(2)
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "primary",
                                              icon: "el-icon-view",
                                            },
                                            on: {
                                              click: _vm.handleOpenQuoteDialog,
                                            },
                                          },
                                          [_vm._v("查看报价")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款凭证" } },
                                  [
                                    _vm.payInfo.payTime
                                      ? _c("span", [
                                          _vm.parseFiles(
                                            _vm.payInfo.paymentProof
                                          ).length > 0
                                            ? _c(
                                                "span",
                                                _vm._l(
                                                  _vm.parseFiles(
                                                    _vm.payInfo.paymentProof
                                                  ),
                                                  function (item, idx) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: idx,
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          "margin-right": "8px",
                                                          "margin-bottom":
                                                            "8px",
                                                        },
                                                      },
                                                      [
                                                        _c("el-image", {
                                                          staticStyle: {
                                                            width: "80px",
                                                            height: "80px",
                                                            "border-radius":
                                                              "4px",
                                                          },
                                                          attrs: {
                                                            src:
                                                              item.url ||
                                                              _vm.$store.getters
                                                                .imgPreviewPrefix +
                                                                item.realName,
                                                            fit: "cover",
                                                            "preview-src-list":
                                                              _vm.getPreviewList(
                                                                _vm.payInfo
                                                                  .paymentProof
                                                              ),
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#909399",
                                                  },
                                                },
                                                [_vm._v("暂无凭证")]
                                              ),
                                        ])
                                      : _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                gap: "8px",
                                                "flex-wrap": "wrap",
                                              },
                                            },
                                            [
                                              _c("input", {
                                                ref: "payProofInput",
                                                staticStyle: {
                                                  display: "none",
                                                },
                                                attrs: {
                                                  type: "file",
                                                  accept: "image/*",
                                                  multiple: "",
                                                },
                                                on: {
                                                  change:
                                                    _vm.handlePayProofFileChange,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary",
                                                    loading:
                                                      _vm.payProofUploading,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.triggerPayProofUpload,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-upload",
                                                  }),
                                                  _vm._v(" 上传付款凭证"),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "warning",
                                                    icon: "el-icon-view",
                                                  },
                                                  on: {
                                                    click: _vm.handleViewPayQr,
                                                  },
                                                },
                                                [_vm._v("查看付款二维码")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.paymentProofUploadList.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-top": "8px",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.paymentProofUploadList,
                                                  function (file) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: file.uid,
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          padding: "2px 0",
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              flex: "1",
                                                              overflow:
                                                                "hidden",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              "white-space":
                                                                "nowrap",
                                                            },
                                                            attrs: {
                                                              title: file.name,
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-paperclip",
                                                            }),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  file.name
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-button", {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "4px",
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            size: "mini",
                                                            icon: "el-icon-delete",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleUploadRemove(
                                                                "paymentProof",
                                                                file
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "付款备注" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "请输入付款备注",
                                        rows: "3",
                                        maxlength: "200",
                                        "show-word-limit": "",
                                        disabled: !!_vm.payInfo.payTime,
                                      },
                                      model: {
                                        value: _vm.payInfo.payRemark,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.payInfo,
                                            "payRemark",
                                            $$v
                                          )
                                        },
                                        expression: "payInfo.payRemark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showPayDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              !_vm.payInfo.payTime
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        icon: "el-icon-money",
                        loading: _vm.paySubmitting,
                      },
                      on: { click: _vm.handleConfirmPay },
                    },
                    [_vm._v("确认付款")]
                  )
                : _c(
                    "span",
                    { staticStyle: { color: "#909399", "font-size": "13px" } },
                    [_vm._v("已付款")]
                  ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "付款二维码",
            visible: _vm.showPayQrDialog,
            width: "420px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPayQrDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "10px" } },
            [
              _c("el-image", {
                staticStyle: { width: "320px", height: "320px" },
                attrs: {
                  src: _vm.payQrUrl,
                  fit: "contain",
                  "preview-src-list": [_vm.payQrUrl],
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "报价信息",
            visible: _vm.showQuoteDialog,
            width: "70%",
            top: "10vh",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showQuoteDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.quoteLoading,
                  expression: "quoteLoading",
                },
              ],
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.quoteList,
                    border: "",
                    size: "small",
                    "max-height": "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionOrder",
                      label: "订单号",
                      "min-width": "180",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "auditName",
                      label: "产品名称",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productionStatus",
                      label: "订单状态",
                      width: "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "报价小计", width: "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#E6A23C",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm
                                        .getQuoteTotal(scope.row.quotes)
                                        .toFixed(2)
                                    )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    padding: "12px 4px 0",
                    "font-size": "14px",
                  },
                },
                [
                  _vm._v("\n        报价合计："),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#E6A23C",
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v("¥" + _vm._s(_vm.quoteTotal.toFixed(2)))]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showQuoteDialog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _vm.canEditPay
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleUseQuoteAmount },
                    },
                    [
                      _vm._v(
                        "确认报价（¥" + _vm._s(_vm.quoteTotal.toFixed(2)) + "）"
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }